var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue2orgTreeCom",attrs:{"align":"center"}},[_c('vue2OrgTree',{attrs:{"data":_vm.tree,"horizontal":_vm.horizontal,"collapsable":_vm.collapsable,"label-class-name":_vm.labelClassName},on:{"on-expand":_vm.onExpand,"on-node-click":_vm.onNodeClick}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8e395564","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrgTree/OrgTree.vue
// module id = 1830
// module chunks = 137